import { ArrayInput, FormDataConsumer, Labeled, NumberField, NumberInput, SelectInput, SimpleFormIterator, TextInput, required, useTranslate } from 'react-admin'
import FormCard from '../../../inputFormComponents/FormCard'
import { FormControl } from "@mui/material"
import ProductInput from '../ProductInput'
import { InvoiceItem, InvoiceType } from '../../../GeneratedClients/FreeBillApi'
import isInvoiceWithoutTax from '../../../domain/invoice/isInvoiceWithoutTax'
import ItemCalculator from '../../../domain/invoice/item/ItemCalculator'
import taxes from '../../../taxes/taxes'

interface IProps {
  invoiceType: InvoiceType
  isSmallBusiness?: boolean
  cardNumber?: number
  description?: JSX.Element
}

const InvoiceItemsCard = ({invoiceType, isSmallBusiness, cardNumber, description}: IProps) => {

  const translate = useTranslate()

  const calculateNetAmountForItem = (item: InvoiceItem) => {
    const itemCalculator = new ItemCalculator(item)
    return itemCalculator.getNetAmount()
  }

  const itemValidator = (list?: any[]) => {
    const isEmpty = !list || list.length === 0
    if(isEmpty) return 'List must contain at least 1 item.'
  }
  
  const defaultTaxInPercent = isInvoiceWithoutTax(invoiceType, isSmallBusiness) ? 0.0 : 0.19
  const defaultInvoiceItems = [{quantity: 1, tax_in_percent: defaultTaxInPercent}]

  return (
    <FormCard 
      fullWidth
      cardNumber={cardNumber}
      description={description}
      title={translate('resources.invoices.form.items')}
      rows={[
        <ArrayInput defaultValue={defaultInvoiceItems} helperText={false} source="invoiceItems" label="resources.items.name" validate={itemValidator} >
          <SimpleFormIterator inline fullWidth >
            <FormDataConsumer>
              {({ getSource }) => {
                return (
                  <ProductInput getSource={getSource} invoiceType={invoiceType} isSmallBusiness={isSmallBusiness} />
                )
              }}
            </FormDataConsumer>
            <TextInput helperText={false} multiline source="description" label="resources.items.description" />
            <NumberInput helperText={false} source="quantity" label="resources.items.quantity" defaultValue={1} validate={required()} />
            <NumberInput helperText={false} source="price" label="resources.common.price" validate={required()} />
            <SelectInput helperText={false} disabled={isInvoiceWithoutTax(invoiceType, isSmallBusiness)} validate={required()} label="resources.common.tax_in_percent" choices={taxes} source="tax_in_percent" />
            <NumberInput helperText={false} source="discount_in_percent" label="resources.common.discount_in_percent" format={v => v ? v * 100 : undefined} parse={v => parseFloat(v??0) / 100} />
            <FormDataConsumer>
              {({ scopedFormData: item }) => {
                return (
                  <Labeled label="resources.invoices.netAmount">
                    <FormControl>
                      <NumberField 
                        record={{value: calculateNetAmountForItem(item!)}} 
                        source="value"
                        options={{ style: 'currency', currency: 'EUR' }}
                      />
                    </FormControl>
                  </Labeled>
                )
              }}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      ]}
    />
  )
}

export default InvoiceItemsCard